import { createFileRoute } from "@tanstack/react-router";
import SendMessagePage from "@/pages/SendMessage";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Done[x] — Act where you talk" },
      {
        name: "description",
        content:
          "Compose and dispatch interactive Slack messages with custom actions, blocks, and callbacks.",
      },
      { property: "og:title", content: "Done[x] — Act where you talk" },
      {
        property: "og:description",
        content:
          "Compose and dispatch interactive Slack messages with custom actions, blocks, and callbacks.",
      },
    ],
  }),
  component: SendMessagePage,
});
